import type { ComponentProps } from "react";
import { Command, CommandItem } from "@volca/ui/components/ui/command";
import { cn } from "@volca/ui/lib/utils";

/**
 * A dialog's search-and-pick list: the job, PO and pricebook pickers. It sits
 * on the dialog's content edge rather than in a box of its own, so the search
 * field spans the content width like any other field, and the group heading,
 * the field's icon and each row's text share one inset.
 */
export const PickerCommand = ({
  className,
  ...props
}: Omit<ComponentProps<typeof Command>, "shouldFilter">) => (
  <Command
    // Results come filtered from the server.
    shouldFilter={false}
    className={cn(
      "overflow-visible bg-transparent p-0",
      "**:data-[slot=command-input-wrapper]:p-0",
      "**:data-[slot=command-group]:px-0 **:data-[slot=command-group]:pt-2 **:data-[slot=command-group]:pb-0",
      className,
    )}
    {...props}
  />
);

/**
 * One choice in a PickerCommand. The pick is marked by CommandItem's own
 * trailing check, so no empty column holds every row's text off the inset.
 */
export const PickerItem = ({
  selected,
  className,
  ...props
}: ComponentProps<typeof CommandItem> & { selected: boolean }) => (
  <CommandItem
    data-checked={selected}
    className={cn(
      // The check sits on the first line, not between the lines below it.
      "items-start gap-3 py-2 [&>svg:last-child]:mt-0.5",
      { "bg-selected text-brand": selected },
      className,
    )}
    {...props}
  />
);
